import { ref } from "vue";
import { useRouter } from "vue-router";
import type { Filters } from "@/types";

export function useIntroSection() {
  const router = useRouter();

  const filters = ref<Filters>({
    location: {},
    online: true,
    inPerson: true,
    dateFrom: new Date(),
    therapy: "",
    therapyType: "",
    radiusKm: null,
  });
  // const location = ref<{ address?: string; lat?: number; lng?: number }>({});
  // const online = ref(false);
  // const inPerson = ref(false);

  function emitSearch() {
    const filtersValue = filters.value;
    router.push({
      path: "/search",
      query: {
        lat: filtersValue.location?.lat?.toString() || "",
        lng: filtersValue.location?.lng?.toString() || "",
        address: filtersValue.location?.address ?? "",
        online: filtersValue.online ? "1" : "0",
        inPerson: filtersValue.inPerson ? "1" : "0",
      },
    });
  }

  // Descomenta si necesitas estas funciones luego
  /*
  function setPlace(place: google.maps.places.PlaceResult) {
    location.value = {
      address: place.formatted_address,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
  }

  function getPayload(payload: any) {
    location.value = payload;
  }
  */

  return {
    filters,
    // location,
    // online,
    // inPerson,
    emitSearch,
    // setPlace,
    // getPayload,
  };
}
